/* eslint-disable react-hooks/exhaustive-deps */

import { useLayoutEffect, useRef } from 'react';
import { Box } from '@zoopla-eng/zds-components/box';

import { PreferencesForm } from '../PreferencesForm';
import {
    headingStyle,
    socialTitleWrapperStyle
} from './PreferencesStep.styles.css';
import { fontGroups } from '@zoopla-eng/zds-components/themes';
import { StepProps } from '../../AuthModal.types';
import { trackSegmentAndGAEvent } from '@zoopla/tracking';

export type PreferencesStepProps = {
    title?: string;
} & StepProps;

export const PreferencesStep = ({
    title,
    onStepCompleted,
    trackingData
}: PreferencesStepProps) => {
    const socialHeader = useRef<HTMLHeadingElement>(null);

    useLayoutEffect(() => {
        if (socialHeader?.current) {
            socialHeader?.current.focus();
        }

        trackSegmentAndGAEvent(
            'Module Shown',
            {
                eventCategory: 'next_best_action',
                eventAction: 'module_shown',
                eventLabel: 'email_marketing_opt_in'
            },
            trackingData.segmentData.page
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {title && (
                <Box pb="M100">
                    <div
                        className={socialTitleWrapperStyle}
                        data-testid="social-login-heading-wrapper"
                    >
                        <h1
                            className={`${headingStyle} ${fontGroups.mug}`}
                            data-testid="social-login-heading"
                            tabIndex={-1}
                            ref={socialHeader}
                        >
                            {title}
                        </h1>
                    </div>
                </Box>
            )}
            <PreferencesForm
                onStepCompleted={onStepCompleted}
                trackingData={trackingData}
            />
        </>
    );
};
